export const CDN_ROUTES = {
  Add: 'add',
  Edit: 'edit',
  BunnyAI: 'bunny-ai',
  Caching: 'caching',
  CachingGeneral: 'general',
  CachingOriginShield: 'origin-shield',
  CachingPermaCache: 'perma-cache',
  CachingRequestCoalescing: 'request-coalescing',
  EdgeRules: 'edge-rules',
  EdgeRulesAdd: 'add',
  EdgeRulesEdit: 'edit',
  General: 'general',
  GeneralHostnames: 'hostnames',
  GeneralOrigin: 'origin',
  GeneralWebSockets: 'websockets',
  GeneralPricing: 'pricing',
  GeneralSafeHop: 'safehop',
  Headers: 'headers',
  Instructions: 'instructions',
  NetworkLimits: 'network-limits',
  Optimizer: 'optimizer',
  OptimizerImageClasses: 'image-classes',
  OptimizerPreloader: 'smart-preloader',
  OptimizerPrerender: 'html-prerender',
  OptimizerBurrow: 'burrow',
  OptimizerSettings: 'settings',
  OptimizerStatistics: 'statistics',
  Security: 'security',
  SecurityErrorPages: 'error-pages',
  SecurityGeneral: 'general',
  SecurityLogging: 'logging',
  SecurityS3Authentication: 's3-authentication',
  SecuritySsl: 'ssl',
  SecurityTokenAuthentication: 'token-authentication',
  Shield: 'shield',
  ShieldDDoS: 'ddos',
  ShieldEventLogs: 'event-logs',
  ShieldOverview: 'overview',
  ShieldRateLimit: 'rate-limit',
  ShieldUploadScanning: 'upload-scanning',
  ShieldWaf: 'waf',
  ShieldSettings: 'settings',
  ShieldWafGeneral: 'general',
  ShieldWafRules: 'rules',
  ShieldWafTriggeredRules: 'triggered-rules',
  ShieldSetup: 'setup',
  TrafficManager: 'traffic-manager',
  ShieldBotDetection: 'bot-detection',
  ShieldAccessLists: 'access-lists',
  ShieldAccessListsCuratedThreatLists: 'curated-threat-lists',
  ShieldAccessListsCustom: 'custom',
  ShieldApiGuardian: 'api-guardian',
} as const;

export type CdnRoutes = keyof typeof CDN_ROUTES;
